type Request = {
  query: any;
  variables?: any;
};

export const makeGqlMock = (request: Request, mockData: any) => ({
  request,
  result: {
    data: mockData,
  },
});
